import { Link } from "react-router-dom";
import { Heart } from "lucide-react";
import { toast } from "sonner";
import { useLanguage } from "../context/LanguageContext";
import { useWishlist } from "../context/WishlistContext";
import { useCart } from "../context/CartContext";
import ProductCard from "../components/ProductCard";

export default function WishlistPage() {
  const { t } = useLanguage();
  const { items, toggleItem } = useWishlist();
  const { addItem } = useCart();

  if (items.length === 0) {
    return (
      <div className="px-6 md:px-12 lg:px-24 py-24 md:py-32 text-center" data-testid="wishlist-page">
        <Heart size={40} strokeWidth={1} className="mx-auto mb-6 text-[#E6E2DD]" />
        <h1
          className="text-2xl md:text-3xl mb-4"
          style={{ fontFamily: "'Playfair Display', serif" }}
        >
          {t("wishlist.title")}
        </h1>
        <p className="text-sm text-[#9CA3AF] tracking-wide mb-8">{t("wishlist.empty")}</p>
        <Link to="/shop" className="btn-luxury" data-testid="wishlist-continue-shopping">
          {t("cart.continue")}
        </Link>
      </div>
    );
  }

  return (
    <div className="px-6 md:px-12 lg:px-24 py-12 md:py-16" data-testid="wishlist-page">
      <h1
        className="text-3xl md:text-4xl mb-12"
        style={{ fontFamily: "'Playfair Display', serif" }}
      >
        {t("wishlist.title")} ({items.length})
      </h1>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 md:gap-8">
        {items.map((product, i) => (
          <div key={product.id} className="relative">
            <ProductCard product={product} index={i} />
            <button
              onClick={() => {
                addItem(product);
                toggleItem(product);
                toast.success(`${product.name} moved to bag`);
              }}
              className="mt-2 w-full btn-luxury-outline text-[10px] py-2"
              data-testid={`move-to-cart-${product.id}`}
            >
              {t("wishlist.move_to_cart")}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
